import { Card } from "@/shared/ui/cards/card";
import { Skeleton } from "@/shared/ui/data-display/skeleton";

export const TournamentInfoRowSkeleton = () => {
  return (
    <Card className="flex flex-col md:flex-row items-center p-4 gap-4">
      {/* Image & Organizer */}
      <div className="flex-shrink-0 w-full md:w-48 flex md:flex-col items-center gap-4">
        <Skeleton className="h-24 w-24 md:h-32 md:w-32 rounded-lg" />
        <div className="flex items-center gap-2">
          <Skeleton className="w-6 h-6 rounded-full" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>

      {/* Main Info */}
      <div className="flex-1 w-full">
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-1/2" />
          <Skeleton className="h-6 w-24" />
        </div>
        <Skeleton className="h-4 w-full mt-2" />
        <Skeleton className="h-4 w-3/4 mt-1" />

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm mt-4">
          <div className="space-y-1">
            <Skeleton className="h-10 w-full" />
          </div>
          <div className="space-y-1">
            <Skeleton className="h-10 w-full" />
          </div>
          <div className="space-y-1">
            <Skeleton className="h-10 w-full" />
          </div>
          <div className="space-y-1">
            <Skeleton className="h-10 w-full" />
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="flex flex-col gap-2 w-full md:w-40 md:ml-4">
        <Skeleton className="h-10 w-full" />
      </div>
    </Card>
  );
};
